import { render, staticRenderFns } from "./sortType.vue?vue&type=template&id=05060582&scoped=true&"
import script from "./sortType.vue?vue&type=script&lang=js&"
export * from "./sortType.vue?vue&type=script&lang=js&"
import style0 from "./sortType.vue?vue&type=style&index=0&id=05060582&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05060582",
  null
  
)

export default component.exports